var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uk-container uk-text-center uk-padding-small uk-animation-fade"},[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_c('img',{staticStyle:{"max-width":"150px"},attrs:{"src":require("@/assets/img/logos/logo.white.png"),"alt":"Logo BRC"}})]),_c('br'),_c('br'),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }